// extracted by mini-css-extract-plugin
module.exports = {"container":"malt-text-input-TextInput-container-f12146d2"};